import {types} from './types';

const setGetBonusHistoryListAction = (payload) => {
    return {
        type: types.SET_HISTORY_LIST,
        payload,
      }
}

export {
  setGetBonusHistoryListAction
}